(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-cod-form"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cart-cod-form')) {
    customElements.define(
      'cart-cod-form',
      class extends HTMLElement {
        async connectedCallback() {
          this.dialog = this.querySelector('dialog');
          this.form = this.querySelector('form');
          this.subtotal = Number(this.querySelector('[data-subtotal]').dataset.subtotalCents);
          this.fmt = new Intl.NumberFormat('es-PE', { style: 'currency', currency: 'PEN' });

          document.querySelectorAll('[data-open-cart-cod]').forEach((trigger) => {
            trigger.hidden = false;
          });
          document.addEventListener('click', (event) => {
            if (!this.isConnected) return;
            if (event.target.closest('[data-open-cart-cod]')) this.open();
          });
          this.querySelectorAll('[data-close]').forEach((el) =>
            el.addEventListener('click', () => this.dialog.close())
          );
          this.dialog.addEventListener('click', (event) => {
            if (event.target === this.dialog) this.dialog.close();
          });
          this.form.addEventListener('change', () => this.updateTotals());
          this.form.addEventListener('submit', (event) => this.submit(event));
          this.updateTotals();

          try {
            const response = await fetch(this.dataset.ubigeoUrl);
            this.ubigeo = await response.json();
            this.initLocationSelects();
          } catch (error) {
            this.fallbackToTextInputs();
          }
        }

        initLocationSelects() {
          const dep = this.form.querySelector('[data-department]');
          const prov = this.form.querySelector('[data-province]');
          const dist = this.form.querySelector('[data-district]');
          Object.keys(this.ubigeo).forEach((name) => dep.add(new Option(name, name)));
          dep.addEventListener('change', () => {
            prov.length = 1;
            dist.length = 1;
            dist.disabled = true;
            Object.keys(this.ubigeo[dep.value] || {}).forEach((name) => prov.add(new Option(name, name)));
            prov.disabled = false;
          });
          prov.addEventListener('change', () => {
            dist.length = 1;
            ((this.ubigeo[dep.value] || {})[prov.value] || []).forEach((name) => dist.add(new Option(name, name)));
            dist.disabled = false;
          });
        }

        fallbackToTextInputs() {
          this.form.querySelectorAll('[data-department], [data-province], [data-district]').forEach((select) => {
            const input = document.createElement('input');
            input.type = 'text';
            input.name = select.name;
            input.required = select.required;
            select.replaceWith(input);
          });
        }

        async open() {
          if (!this.dialog.open) this.dialog.showModal();

          // Refresh line items live so AJAX-added products are included.
          try {
            const response = await fetch(window.Shopify.routes.root + 'cart.js');
            const cart = await response.json();
            this.items = cart.items.map((item) => ({
              variant_id: String(item.variant_id),
              quantity: item.quantity,
            }));
            this.subtotal = cart.total_price;
            const list = this.querySelector('.cod__cart-items');
            if (list) {
              list.innerHTML = cart.items
                .map(
                  (item) => `
                    <li class="cod__cart-item">
                      <span class="cod__cart-item-qty">${item.quantity}×</span>
                      <span class="cod__cart-item-title">${item.product_title}
                        ${item.variant_title ? `<small>${item.variant_title}</small>` : ''}
                      </span>
                      <span class="cod__cart-item-price">${this.fmt.format(item.final_line_price / 100)}</span>
                    </li>`
                )
                .join('');
            }
            this.updateTotals();
          } catch (error) {
            // Server-rendered items stay as fallback.
          }
        }

        shippingPrice() {
          const checked = this.form.querySelector('[name="shipping_label"]:checked');
          return checked ? Number(checked.dataset.shippingPrice) : 0;
        }

        updateTotals() {
          const shipping = this.shippingPrice();
          const label = this.querySelector('[data-shipping-total]');
          if (shipping > 0) label.textContent = this.fmt.format(shipping / 100);
          const total = this.fmt.format((this.subtotal + shipping) / 100);
          this.querySelector('[data-total]').textContent = total;
          this.querySelector('[data-total-button]').textContent = total;
        }

        async submit(event) {
          event.preventDefault();
          const error = this.querySelector('[data-error]');
          error.hidden = true;
          if (!this.form.reportValidity()) return;

          const button = this.form.querySelector('.cod__submit');
          button.setAttribute('aria-busy', 'true');

          const data = Object.fromEntries(new FormData(this.form));
          data.intent = 'complete';
          data.shipping_price = this.shippingPrice();
          data.items =
            this.items ||
            this.dataset.items.split(',').map((pair) => {
              const [variant_id, quantity] = pair.split(':');
              return { variant_id, quantity: Number(quantity) };
            });
          if (!data.items.length) {
            error.textContent = error.dataset.message;
            error.hidden = false;
            button.removeAttribute('aria-busy');
            return;
          }

          try {
            const response = await fetch(this.dataset.endpoint, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify(data),
            });
            const result = await response.json().catch(() => ({}));
            if (!response.ok || !result.ok) throw new Error(result.error || 'request_failed');

            this.querySelector('[data-success]').hidden = false;
            this.form.querySelector('.cod__fields').hidden = true;
            button.hidden = true;
            fetch(window.Shopify.routes.root + 'cart/clear.js', { method: 'POST' }).catch(() => {});
            setTimeout(() => {
              window.location.href = this.dataset.whatsapp;
            }, 1200);
          } catch (err) {
            error.textContent = error.dataset.message;
            error.hidden = false;
          } finally {
            button.removeAttribute('aria-busy');
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  if (!customElements.get('cart-drawer')) {
    customElements.define(
      'cart-drawer',
      class extends HTMLElement {
        connectedCallback() {
          this.bind();

          // Header cart icon opens the drawer instead of navigating.
          // The link keeps its href, so without JS it still goes to /cart.
          const headerCart = document.querySelector('.header__cart');
          if (headerCart) {
            headerCart.addEventListener('click', (event) => {
              event.preventDefault();
              this.open();
            });
          }
        }

        bind() {
          this.dialog = this.querySelector('dialog');
          this.querySelectorAll('[data-close]').forEach((el) =>
            el.addEventListener('click', () => this.dialog.close())
          );
          this.dialog?.addEventListener('click', (event) => {
            if (event.target === this.dialog) this.dialog.close();
          });
          if (document.querySelector('cart-cod-form')) {
            this.querySelectorAll('[data-open-cart-cod]').forEach((button) => {
              button.hidden = false;
              button.addEventListener('click', () => this.dialog.close());
            });
          }
        }

        refresh(sectionHtml) {
          const doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
          const next = doc.querySelector('cart-drawer');
          if (next) {
            this.innerHTML = next.innerHTML;
            this.bind();
          }
          this.open();

          const badge = document.querySelector('.header__cart-count');
          const count = doc.querySelector('[data-cart-count]');
          if (badge && count) badge.textContent = count.dataset.cartCount;
        }

        open() {
          if (this.dialog && !this.dialog.open) this.dialog.showModal();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cod-form"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cod-form')) {
    customElements.define(
      'cod-form',
      class extends HTMLElement {
        async connectedCallback() {
          this.dialog = this.querySelector('dialog');
          this.form = this.querySelector('form');
          this.price = Number(this.dataset.price);
          this.currency = this.dataset.currency || 'PEN';
          this.fmt = new Intl.NumberFormat('es-PE', { style: 'currency', currency: this.currency });

          this.pay = 1;
          this.ship = 1;
          this.packageLabel = '';
          this.qtyInput = this.form.querySelector('[name="quantity"]');

          // Offers rendered by the product section drive the quantities.
          this.offers = document.querySelector('pdp-offers');
          if (this.offers) {
            this.form.querySelector('[data-qty-row]').hidden = true;
            this.qtyInput = null;
            const selected =
              this.offers.querySelector('[aria-pressed="true"]') || this.offers.querySelector('.pdp__offer');
            if (selected) this.applyPackage(selected.dataset);
            window.addEventListener('cod:package', (event) => {
              if (this.isConnected) this.applyPackage(event.detail);
            });
          }
          this.form.addEventListener('change', () => this.updateTotals());
          this.form.addEventListener('submit', (event) => this.submit(event));
          this.updateTotals();

          // Delegated: any current or future [data-open-cod] opens this modal.
          document.querySelectorAll('[data-open-cod]').forEach((trigger) => {
            trigger.hidden = false;
          });
          document.addEventListener('click', (event) => {
            if (!this.isConnected) return;
            if (event.target.closest('[data-open-cod]')) this.open();
          });
          this.querySelectorAll('[data-close]').forEach((el) =>
            el.addEventListener('click', () => this.dialog.close())
          );
          this.dialog.addEventListener('click', (event) => {
            if (event.target === this.dialog) this.dialog.close();
          });

          this.draftKey = 'cod-draft-id';
          this.partialSent = Boolean(sessionStorage.getItem(this.draftKey));
          ['full_name', 'phone'].forEach((name) => {
            this.form
              .querySelector(`[name="${name}"]`)
              .addEventListener('blur', () => this.maybeSendPartial());
          });

          try {
            const response = await fetch(this.dataset.ubigeoUrl);
            this.ubigeo = await response.json();
            this.initLocationSelects();
          } catch (error) {
            this.fallbackToTextInputs();
          }
        }

        open() {
          if (!this.dialog.open) this.dialog.showModal();

          // Keep the product in the Shopify cart too, so the native
          // cart/checkout path stays available if the modal is closed.
          if (!this.cartSeeded) {
            this.cartSeeded = true;
            fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: Number(this.dataset.variant), quantity: 1 }),
            }).catch(() => {});
          }
        }

        applyPackage(detail) {
          this.pay = Number(detail.pay);
          this.ship = Number(detail.ship);
          this.packageLabel = detail.label || '';
          this.form.querySelector('[name="package_label"]').value = this.packageLabel;
          this.querySelector('[data-package-label]').textContent = this.packageLabel;
          this.updateTotals();
        }

        initLocationSelects() {
          const dep = this.form.querySelector('[data-department]');
          const prov = this.form.querySelector('[data-province]');
          const dist = this.form.querySelector('[data-district]');
          Object.keys(this.ubigeo).forEach((name) => dep.add(new Option(name, name)));

          dep.addEventListener('change', () => {
            prov.length = 1;
            dist.length = 1;
            dist.disabled = true;
            Object.keys(this.ubigeo[dep.value] || {}).forEach((name) => prov.add(new Option(name, name)));
            prov.disabled = false;
          });

          prov.addEventListener('change', () => {
            dist.length = 1;
            ((this.ubigeo[dep.value] || {})[prov.value] || []).forEach((name) => dist.add(new Option(name, name)));
            dist.disabled = false;
          });
        }

        fallbackToTextInputs() {
          this.form.querySelectorAll('[data-department], [data-province], [data-district]').forEach((select) => {
            const input = document.createElement('input');
            input.type = 'text';
            input.name = select.name;
            input.required = select.required;
            select.replaceWith(input);
          });
        }

        shippingPrice() {
          const checked = this.form.querySelector('[name="shipping_label"]:checked');
          return checked ? Number(checked.dataset.shippingPrice) : 0;
        }

        currentQuantities() {
          if (this.qtyInput && !this.offers) {
            const qty = Math.max(1, Number(this.qtyInput.value || 1));
            return { pay: qty, ship: qty };
          }
          return { pay: this.pay, ship: this.ship };
        }

        updateTotals() {
          const { pay, ship } = this.currentQuantities();
          const subtotal = this.price * pay;
          const shipping = this.shippingPrice();
          const shippingLabel = this.querySelector('[data-shipping-total]');

          this.querySelector('[data-qty-badge]').textContent = ship;
          this.querySelector('[data-line-total]').textContent = this.fmt.format(subtotal / 100);
          this.querySelector('[data-subtotal]').textContent = this.fmt.format(subtotal / 100);
          if (shipping > 0) shippingLabel.textContent = this.fmt.format(shipping / 100);
          const total = this.fmt.format((subtotal + shipping) / 100);
          this.querySelector('[data-total]').textContent = total;
          this.querySelector('[data-total-button]').textContent = total;
        }

        payload(intent) {
          const data = Object.fromEntries(new FormData(this.form));
          const { pay, ship } = this.currentQuantities();
          data.intent = intent;
          data.pay_qty = pay;
          data.ship_qty = ship;
          delete data.quantity;
          return data;
        }

        async maybeSendPartial() {
          if (this.partialSent) return;
          const name = this.form.querySelector('[name="full_name"]').value.trim();
          const phone = this.form.querySelector('[name="phone"]').value.replace(/\s/g, '');
          if (name.length < 3 || !/^9\d{8}$/.test(phone)) return;

          this.partialSent = true;
          try {
            const response = await fetch(this.dataset.endpoint, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify(this.payload('partial')),
            });
            const result = await response.json();
            if (result.ok && result.draft_id) sessionStorage.setItem(this.draftKey, result.draft_id);
          } catch {
            this.partialSent = false;
          }
        }

        async submit(event) {
          event.preventDefault();
          const error = this.querySelector('[data-error]');
          error.hidden = true;

          if (!this.form.reportValidity()) return;

          const button = this.form.querySelector('.cod__submit');
          button.setAttribute('aria-busy', 'true');

          const data = this.payload('complete');
          data.shipping_price = this.shippingPrice();
          const draftId = sessionStorage.getItem(this.draftKey);
          if (draftId) data.draft_id = draftId;

          try {
            const response = await fetch(this.dataset.endpoint, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify(data),
            });
            const result = await response.json().catch(() => ({}));
            if (!response.ok || !result.ok) throw new Error(result.error || 'request_failed');

            sessionStorage.removeItem(this.draftKey);
            this.querySelector('[data-success]').hidden = false;
            this.form.querySelector('.cod__fields').hidden = true;
            button.hidden = true;
            setTimeout(() => {
              window.location.href = this.dataset.whatsapp;
            }, 1200);
          } catch (err) {
            error.textContent = error.dataset.message;
            error.hidden = false;
          } finally {
            button.removeAttribute('aria-busy');
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["countdown-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('countdown-timer')) {
    customElements.define(
      'countdown-timer',
      class extends HTMLElement {
        connectedCallback() {
          const raw = (this.dataset.ends || '').trim().replace(' ', 'T');
          this.ends = new Date(raw);
          if (Number.isNaN(this.ends.getTime())) return;

          this.values = {
            days: this.querySelector('[data-unit="days"]'),
            hours: this.querySelector('[data-unit="hours"]'),
            minutes: this.querySelector('[data-unit="minutes"]'),
            seconds: this.querySelector('[data-unit="seconds"]'),
          };

          this.tick();
          this.interval = setInterval(() => this.tick(), 1000);
        }

        disconnectedCallback() {
          clearInterval(this.interval);
        }

        tick() {
          const diff = this.ends.getTime() - Date.now();

          if (diff <= 0) {
            clearInterval(this.interval);
            const bar = this.closest('.countdown');
            if (bar) bar.setAttribute('hidden', '');
            return;
          }

          this.removeAttribute('hidden');
          const s = Math.floor(diff / 1000);
          this.values.days.textContent = Math.floor(s / 86400);
          this.values.hours.textContent = String(Math.floor((s % 86400) / 3600)).padStart(2, '0');
          this.values.minutes.textContent = String(Math.floor((s % 3600) / 60)).padStart(2, '0');
          this.values.seconds.textContent = String(s % 60).padStart(2, '0');
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  if (!customElements.get('qty-input')) {
    customElements.define(
      'qty-input',
      class extends HTMLElement {
        connectedCallback() {
          this.input = this.querySelector('input');
          this.querySelectorAll('button').forEach((button) => {
            button.hidden = false;
            button.addEventListener('click', () => {
              const step = Number(button.dataset.step);
              const next = Math.max(1, Number(this.input.value || 1) + step);
              this.input.value = next;
              this.input.dispatchEvent(new Event('change', { bubbles: true }));
            });
          });
        }
      }
    );
  }

  if (!customElements.get('pdp-offers')) {
    customElements.define(
      'pdp-offers',
      class extends HTMLElement {
        connectedCallback() {
          this.buttons = [...this.querySelectorAll('.pdp__offer')];
          this.buttons.forEach((button) => {
            button.addEventListener('click', () => this.select(button));
          });
        }

        select(active) {
          this.buttons.forEach((b) => b.setAttribute('aria-pressed', String(b === active)));
          this.announce(active);
        }

        selected() {
          return this.querySelector('[aria-pressed="true"]') || this.buttons[0];
        }

        announce(button) {
          window.dispatchEvent(
            new CustomEvent('cod:package', {
              detail: {
                pay: Number(button.dataset.pay),
                ship: Number(button.dataset.ship),
                label: button.dataset.label,
              },
            })
          );
        }
      }
    );
  }

  // Reveal COD triggers as soon as the modal exists in the DOM — no
  // dependency on the modal's own script finishing without errors.
  if (document.querySelector('cod-form')) {
    document.querySelectorAll('[data-open-cod]').forEach((button) => {
      button.hidden = false;
    });
  }

  // Instant variant switching: intercept variant-chip links, fetch the
  // new page, and swap <main> in place (custom elements re-upgrade on
  // insertion, so the COD modal and offers rebind automatically).
  document.addEventListener('click', async (event) => {
    const chip = event.target.closest('.pdp__options a.pdp__chip');
    if (!chip) return;
    event.preventDefault();
    const main = document.getElementById('main-content');
    main.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(chip.href);
      const html = await response.text();
      const next = new DOMParser().parseFromString(html, 'text/html').getElementById('main-content');
      if (!next) throw new Error('swap_failed');
      main.replaceChildren(...next.childNodes);
      history.replaceState({}, '', chip.href);
    } catch (error) {
      window.location.href = chip.href;
    } finally {
      main.removeAttribute('aria-busy');
    }
  });

  document.querySelectorAll('[data-quick-add]').forEach((button) => {
    button.hidden = false;
    button.addEventListener('click', async () => {
      button.setAttribute('aria-busy', 'true');
      try {
        const body = new FormData();
        body.append('id', button.dataset.variant);
        body.append('quantity', '1');
        body.append('sections', 'cart-drawer');
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body,
        });
        const data = await response.json();
        if (response.ok) {
          document.querySelector('cart-drawer')?.refresh(data.sections['cart-drawer']);
        }
      } catch (error) {
        window.location.href = window.Shopify.routes.root + 'cart';
      } finally {
        button.removeAttribute('aria-busy');
      }
    });
  });

  if (!customElements.get('product-form')) {
    customElements.define(
      'product-form',
      class extends HTMLElement {
        connectedCallback() {
          this.form = this.querySelector('form');
          if (!this.form) return;
          this.form.addEventListener('submit', (event) => this.submit(event));

          const sticky = document.getElementById('PdpSticky');
          const atc = this.querySelector('.pdp__atc');
          if (sticky && atc && 'IntersectionObserver' in window) {
            new IntersectionObserver(
              ([entry]) => {
                sticky.hidden = entry.isIntersecting;
              },
              { rootMargin: '-80px 0px 0px 0px' }
            ).observe(atc);
          }
        }

        async submit(event) {
          const drawer = document.querySelector('cart-drawer');
          if (!drawer) return;
          event.preventDefault();

          const button = this.form.querySelector('[name="add"]');
          button.setAttribute('aria-busy', 'true');

          try {
            const body = new FormData(this.form);
            body.append('sections', 'cart-drawer');
            const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              headers: { Accept: 'application/json' },
              body,
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.description || data.message);
            drawer.refresh(data.sections['cart-drawer']);
          } catch (error) {
            this.form.submit();
          } finally {
            button.removeAttribute('aria-busy');
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
